var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3999 34.999C70.3999 54.3288 54.7297 69.999 35.3999 69.999C16.0699 69.999 0.399902 54.3288 0.399902 34.999C0.399902 15.669 16.0699 -0.000976562 35.3999 -0.000976562C54.7297 -0.000976562 70.3999 15.669 70.3999 34.999ZM15.5666 20.999C15.5666 19.074 17.1416 18.6657 19.0666 18.6657H54.0666C55.9916 18.6657 56.3999 19.074 56.3999 20.999V51.3324C56.3999 53.2574 55.9916 53.6657 54.0666 53.6657H17.8999C15.9749 53.6657 15.5666 53.2574 15.5666 51.3324V20.999ZM35.9832 36.749L19.0666 25.6657V50.1657H52.8999V25.6657L35.9832 36.749ZM35.9832 33.249L19.0666 22.1657H52.8999L35.9832 33.249Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.0113127f19e7c5b0092383e3c4b0f025.svg";
export { ForwardRef as ReactComponent };